"use client";

import { Skeleton } from "../ui/skeleton";
import type { CourseLoadingProps } from "./course-loading.types";

/** Reserve the course artwork and content while the authorised detail loads. */
export function CourseDetailSkeleton({ label }: CourseLoadingProps) {
  return (
    <div role="status" aria-label={label} aria-busy="true">
      <span className="sr-only">{label}</span>
      <div
        aria-hidden="true"
        className="space-y-5 motion-reduce:[&_.animate-pulse]:animate-none"
      >
        <div className="-mx-4">
          <Skeleton className="aspect-video w-full rounded-none" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 w-9 shrink-0 rounded-full" />
          <Skeleton className="h-4 w-1/2" />
          <Skeleton className="ml-auto h-4 w-16" />
        </div>
        <div className="space-y-2">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-6 w-3/4" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-4 w-1/3" />
          <div className="flex -space-x-2">
            <Skeleton className="h-9 w-9 rounded-full" />
            <Skeleton className="h-9 w-9 rounded-full" />
          </div>
        </div>
        <div className="space-y-3 border-t border-border pt-4">
          <Skeleton className="h-8 w-1/3" />
          <Skeleton className="h-3 w-full" />
        </div>
        <div className="space-y-3">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    </div>
  );
}
